import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const BASE = `${API_URL}/api/customer-orders`;

const getUploadUrl = async (filename, contentType) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${BASE}/scan/upload-url`,
    { filename, contentType },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data; // { uploadUrl, key }
};

const uploadToS3 = async (uploadUrl, file) => {
  const response = await fetch(uploadUrl, { method: 'PUT', body: file });
  if (!response.ok) throw new Error('S3 upload failed');
};

const scanPo = async ({ documentKey, documentOriginalName, contentType }) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${BASE}/scan`,
    { documentKey, documentOriginalName, contentType },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const getScan = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${BASE}/scan/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const confirmScan = async (id, data) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${BASE}/scan/${id}/confirm`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const discardScan = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${BASE}/scan/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const poScanService = {
  getUploadUrl,
  uploadToS3,
  scanPo,
  getScan,
  confirmScan,
  discardScan,
};

export default poScanService;
